import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import ScrollSmoother from "gsap/ScrollSmoother";
import Swiper from "swiper/bundle";

//import Featherlight from "featherlight";

//import "featherlight/release/featherlight.min.js";
//import "featherlight/release/featherlight.gallery.min.js";


// Register plugins
gsap.registerPlugin(
  ScrollTrigger,
  ScrollSmoother,
  ScrollToPlugin,
);

window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.ScrollSmoother = ScrollSmoother;
window.ScrollToPlugin = ScrollToPlugin;
window.Swiper = Swiper;
//window.Featherlight = Featherlight;